import * as React from 'react';

import { AssignmentCompleteIcon, AssignmentErrorIcon, LockCircledIcon } from '@coursera/cds-icons';

import GrayCircle from 'bundles/course-frame/components/course-outline/icons/GrayCircle';
import type { Item } from 'bundles/learner-progress/types/Item';
import { getIsLocked } from 'bundles/learner-progress/utils/Item';

import _t from 'i18n!nls/course-frame';

type Props = {
  computedItem: Item;
};

/**
 * Get the label for the status icon to be used for link's aria-label and a11y.
 * The list of conditions in this util should match the list of conditions in the StatusIcon component.
 * @param computedItem
 * @returns
 */
export const getStatusIconLabel = (computedItem: Item) => {
  if (computedItem.isFailed) {
    return _t('Failed');
  }
  if (!getIsLocked(computedItem) && (computedItem.isCompleted || computedItem.isPassed)) {
    return _t('Completed');
  }
  if (getIsLocked(computedItem)) {
    return _t('Locked');
  }
  return _t('Not submitted');
};

const StatusIcon = ({ computedItem }: Props) => {
  const iconLabel = getStatusIconLabel(computedItem);
  if (computedItem.isFailed) {
    return (
      <AssignmentErrorIcon title={iconLabel} color="warning" size="medium" data-testid="learn-item-warning-icon" />
    );
  }
  if (!getIsLocked(computedItem) && (computedItem.isCompleted || computedItem.isPassed)) {
    return (
      <AssignmentCompleteIcon title={iconLabel} color="success" size="medium" data-testid="learn-item-success-icon" />
    );
  }

  if (getIsLocked(computedItem)) {
    return <LockCircledIcon title={iconLabel} color="support" size="medium" data-testid="learn-item-lock-icon" />;
  }

  return <GrayCircle title={iconLabel} />;
};

export default StatusIcon;
